const topics = [
  { id: 1, name: '热血漫画', icon: 'ri-fire-line', count: '1280部', heat: '热门', highlight: true },
  { id: 2, name: '恋爱漫画', icon: 'ri-heart-line', count: '960部', heat: '推荐' },
  { id: 3, name: '玄幻修仙', icon: 'ri-moon-line', count: '1850部', heat: '火爆', highlight: true },
  { id: 4, name: '都市生活', icon: 'ri-building-line', count: '720部', heat: '新晋' },
  { id: 5, name: '悬疑推理', icon: 'ri-search-eye-line', count: '540部', heat: '热门' },
  { id: 6, name: '搞笑日常', icon: 'ri-emotion-laugh-line', count: '860部', heat: '推荐' },
  { id: 7, name: '古风仙侠', icon: 'ri-goblet-line', count: '670部', heat: '经典' },
  { id: 8, name: '科幻未来', icon: 'ri-rocket-line', count: '490部', heat: '新锐' },
  { id: 9, name: '冒险奇幻', icon: 'ri-compass-3-line', count: '930部', heat: '人气' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            探索九妖漫画网精选漫画话题分类，找到属于您的阅读兴趣方向
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {topics.map((topic) => (
            <a
              key={topic.id}
              href="#cards"
              className={`group relative flex flex-col items-center gap-2 p-4 md:p-5 rounded-xl cursor-pointer transition-all duration-200 ${
                topic.highlight
                  ? 'bg-primary-50/70 hover:bg-primary-100/70'
                  : 'bg-background-100 hover:bg-background-200/70'
              }`}
            >
              <span className={`w-12 h-12 flex items-center justify-center rounded-full text-xl ${
                topic.highlight
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200 text-foreground-600 group-hover:bg-primary-100 group-hover:text-primary-600'
              } transition-colors`}>
                <i className={topic.icon}></i>
              </span>
              <span className="font-medium text-sm text-foreground-800 whitespace-nowrap">
                {topic.name}
              </span>
              <div className="flex items-center gap-2">
                <span className="text-xs text-foreground-400 whitespace-nowrap">{topic.count}</span>
                <span className={`text-xs px-1.5 py-0.5 rounded-full font-medium whitespace-nowrap ${
                  topic.heat === '火爆' ? 'bg-primary-100 text-primary-600' :
                  topic.heat === '热门' ? 'bg-accent-100 text-accent-700' :
                  'bg-secondary-100 text-secondary-700'
                }`}>
                  {topic.heat}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}